<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-22 13:41:11
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/AddressDet/index.vue
-->
<template>
  <!-- 订单详情地址信息 -->
  <div v-if="getUserOrder.address" class="address_con">
    <div class="text_left add_top">
      <img
        src="@/assets/order/icon_location@2x.png"
        alt=""
        class="icon_loaction"
      />
      <span class="font14 font_weight600 colo087 line_height_20 add_name"
        >{{ getUserOrder.address.name }} {{ getUserOrder.address.phone }}</span
      >
    </div>
    <div class="font12 font_weight400 colo055 line_height_17 text_left add_add">
      {{ getUserOrder.address.province }} {{ getUserOrder.address.city }}
      {{ getUserOrder.address.district }} {{ getUserOrder.address.addressLine }}
    </div>
    <div class="botom_line"></div>
    <img src="@/assets/common/address_line@2x.png" alt="" class="add_line" />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  }
};
</script>

<style lang="less" scoped>
.address_con {
  background: #fff;
  border-radius: 8px 8px 0 0;
  // height: 72px;
  position: relative;
  .add_top {
    font-size: 0;
    .icon_loaction {
      width: 16px;
      margin: 14px 12px 0;
      vertical-align: middle;
    }
    .add_name {
      display: inline-block;
      vertical-align: middle;
      margin-top: 12px;
    }
  }
  .add_add {
    padding: 8px 12px 0 40px;
  }
  .add_line {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    display: block;
    width: 100%;
    height: 3px;
    // padding-top: 12px;
  }
  .botom_line {
    margin-top: 15px;
    background: #f6f7f8;
    height: 12px;
  }
}
</style>
